// extracted by mini-css-extract-plugin
export default {"container":"VDy2LYOpeN0vO9JOz3Hl"};